import { Component } from '@angular/core';

import { CultureComponent } from '@camelot/ui';
import { Culture } from '@camelot/utils';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-culture-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [CultureComponent],
  template: `
    @if (this.value) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-culture class="d-flex" [cultures]="[this.value]"></cam-culture>
      </div>
    }
  `,
})
export class GridCultureCellComponent extends AbstractCellComponent<any, Culture> {}
